import { Text } from "../../../../../components/general/Text";
import styles from "../../../../../styles/variables.scss";

const DISABLED_FEATURES = [
  "最新の勉強記録の閲覧ができなくなります",
  "メッセージの送受信ができなくなります",
  "保護者LINE連携をしている場合は同時にLINE連携も停止されます",
  "連携中生徒の本棚にデジタル教材が存在する場合は、生徒アプリの本棚から削除されます",
];

export const DisabledFeaturesNotice = () => {
  return (
    <div className="bg-white px-8 mb-6">
      <Text size="md" bold className="mb-3">
        停止すると以下の機能が利用できなくなります。
      </Text>
      <div
        className="m-0 py-4 px-6 rounded"
        style={{ backgroundColor: styles.colorGrayLighten3 }}
      >
        <ul className="mb-1">
          {DISABLED_FEATURES.map((feature) => (
            <li key={feature} className="leading-[1.8] list-inside list-disc">
              {feature}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
